// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smcx-embed,.smcx-embed>.smcx-iframe-container{max-width:unset!important}", ""]);
// Exports
module.exports = exports;
